'use client';

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Survey from './Survey';

const SurveyController = () => {
	const [surveyRef, setSurveyRef] = useState<Element[] | null>(null);
	const [questions, setQuestions] = useState(['']);

	useEffect(() => {
		const surveyContainer = Array.from(
			document.querySelectorAll('div[data-survey]'),
		);
		const questions = surveyContainer.map(
			(container) =>
				container.getAttribute('data-survey') || 'No question found',
		);

		if (surveyContainer) {
			setSurveyRef(surveyContainer);
			setQuestions(questions);
		}
	}, []);

	if (!surveyRef) {
		return null;
	}

	return (
		<>
			{surveyRef.map((ref, i) => (
				<div key={i}>
					{createPortal(<Survey question={questions[i]} />, ref)}
				</div>
			))}
		</>
	);
};

export default SurveyController;
